import {Component, OnInit, Inject} from '@angular/core';
import {SessionService} from '../Services/Session/session-service.service';
import {Router} from '@angular/router';
//import * as firebase from "firebase";
import {FirebaseService} from "../Services/Firebase/firebase.service";
import {environment} from '../../environments/environment';
import {MessageService} from 'primeng/api';
import {Validators, FormControl, FormGroup, FormBuilder} from '@angular/forms';
import {ApiService} from '../Services/Api/api.service';
import { RealmService } from '../Services/Realm/realm.service';
import {IpServiceService} from '../Services/ip-service.service';
import {AuthService} from '../auth.service';
import {DatePipe} from '@angular/common';
//import {DialogModule} from 'primeng/dialog';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['../../assets/layout/style/layout.css','./login.component.css'],
  providers: [MessageService, CookieService]
})
export class LoginComponent implements OnInit {
  userform: FormGroup;
  display: boolean = false;
  submitted: boolean;
  saveCookies: boolean = false;
  items: any[];
  selectedCity: string;
  cardTitle: string;
  dateTitle: string;
  loginBtnTitle: string;
  masks = 'dd/MM/yyyy';
  dob: string;
  cCode: string;
  card: string;
  datas: string;
  yearRange: string;
  env = environment;
  idWithOutValidation: string;
  matchCardNumber: boolean = false;
  cards: string[];
  cookieUserId: string;
  cookieUserBirthday: string;
  datetmp: Date | undefined;
  countryTitle: any;
  policiesExclude: string;
  countryReq: string;

  // tslint:disable-next-line:max-line-length
  constructor(private realm: RealmService, private api: ApiService, private st: SessionService,
              private fb: FormBuilder, private auth: AuthService,
              private messageService: MessageService, private router: Router, private  ip: IpServiceService, private firebase: FirebaseService,
              private cookieService: CookieService) {
  }
  ngOnInit(): void {
    this.env.isContentLoading = false;
    
    //this.countryTitle = this.cookieService.get('userCountry');
    let usrCountry = this.cookieService.get('userCountry');
    console.log("cookie: "+ usrCountry);

    this.firebase.fetchActivate().then(() => {
      this.getCountry();
    });

    this.st.saveParam('logged', 'false');
    this.yearRange = `${new Date().getFullYear() - 120}:${new Date().getFullYear()}`;
    //this.env.usrGTM = this.cCode == '504';
    //console.log("cCode: ", this.cCode);
    console.log("usrGTM: ", this.env.usrGTM);
    console.log("usrHN: ", this.env.usrHN);
    this.ip.getIPAddress();
    this.ip.ipAdress$.subscribe( (p: any) => {
      console.log("ip: ", p);
      this.st.saveParam('ip', p.ip);
      //this.st.saveParam('ip', p);
      this.st.saveParam('dataIP', p.ip);
    });
    this.firebase.fetchActivate().then(() => {
      console.log("conexion exitosa");
      this.getCardNumbers();
      this.getPoliciesExclude();
    }).catch(() => {
      console.log("error en conexion ");
    });
    /*
    this.ip.getIPAddress();
    this.ip.ipAdress$.subscribe( (ip: any) => {
      this.st.saveParam('ip', ip.toString());
    });*/
    this.realm.getCountries().then((data:any) =>{
      this.items = data.data.countryAppSettingsOrms;
      console.log("this.items: ", this.items);
      console.log("usrCountry: "+ usrCountry);
      if ( usrCountry != null && usrCountry != undefined && usrCountry.length != 0) {
        this.saveCookies = true;
        this.countryTitle = this.items.find((cn:any) => cn.code == usrCountry)
        this.card = this.cookieService.get('userId');
        let bdaytmp = this.cookieService.get('userBirthday');
        let dateParts:any = bdaytmp.split("/");
        console.log("bdaytmp: "+ bdaytmp);
        this.datetmp =   new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]); 
        console.log("dattmp: "+ this.datetmp);
        let day = this.datetmp.getDay();
        console.log("day: "+ day);
        console.log("month: "+ this.datetmp.getMonth());
      }
    });
    this.api.responseApiLogin$
      .subscribe(data => {
        console.log('data ws: ', data);
        const dat = JSON.parse(JSON.stringify(data));
        if (data !== undefined) {
          this.env.isContentLoading = false;
        }
        // @ts-ignore
        
        if (dat.code === 701) {
          this.auth.setSimpleLogged(true);
          // @ts-ignore
          const s: object = dat.result;
          if (s.hasOwnProperty('success')) {
            // @ts-ignore
            // this.messageService.add({severity: 'info', summary: 'Success', detail: 'Form Submitted', sticky: false});
            
            const a = s.success;
            this.st.savedata(JSON.stringify(a),  this.cCode, this.dob, this.card, '', '');
            this.env.usrGTM = this.cCode == '502';
            console.log("cCode: ", this.cCode);
            console.log("usrGTM: ", this.env.usrGTM);
            const deviceFound: boolean = a.deviceFound;
            const insuredFound: boolean = a.insuredFound;
            this.env.uniqueFormulary = (a.contactCode == 5043 || a.contactCode == 5044);
            this.env.currentPolicy = a.policy;
            this.env.policyHolderCardNumberOld = a.policyHolderCompleteCardNumberOld;

            this.st.saveParam('currentPolicySess', a.policy);
            this.st.saveParam('policyHolderCardNumberOldSess', 'prueba si guarda algo la sesion');
            console.log("currentPolicy: "+ this.env.currentPolicy);
            console.log("value saveCookies: "+ this.saveCookies);
            if (this.saveCookies) {
              console.log("Seteando cookies");
              this.cookieService.set('userId', this.card,14);
              this.cookieService.set('userBirthday',this.dob,14);
              this.cookieService.set('userCountry', this.cCode,14);
            }
            
            console.log('deviceFound  ' + deviceFound );
            console.log('insuredFound  ' + insuredFound );
            console.log('this.card: '+this.card);
            /*this.cards.map((card:any) => {
              console.log("card: ", card);
              if (this.card.indexOf(card) !== -1) {
                console.log("insured and device found");
                this.matchCardNumber = true;
              } 
            })*/
            if(false) {
              this.auth.setOtpIn(true);
              this.auth.setRegisterIn(true);
              this.router.navigate(['/home/content']);
            }
            else {
            //if (!this.matchCardNumber) {
              if (!deviceFound && insuredFound) {
                // mandar al sms
                console.log("device not found");
                this.auth.setOtpIn(false);
                this.auth.setRegisterIn(true);
                this.env.sendOtpNewDevice = false;
                this.router.navigate(['otp']);
                //SOLUCION ALTERNA
                //this.auth.setOtpIn(true);
                //this.auth.setRegisterIn(true);
                //this.router.navigate(['/home/content']);
              }
              if (deviceFound && !insuredFound) {
                  console.log("insured not found");
                  // crear registro completo
                  this.auth.setOtpIn(false);
                  this.auth.setRegisterIn(false);
                  this.router.navigate(['register']);
              }
              if (!deviceFound && !insuredFound) {
                  console.log("insured and device not found");
                  // crear registro completo
                  this.auth.setOtpIn(false);
                  this.auth.setRegisterIn(false);
                  this.router.navigate(['register']);
              }
              if (deviceFound && insuredFound) {
                // ingresa hasta el home
                console.log("insured and device found");
                this.auth.setOtpIn(true);
                this.auth.setRegisterIn(true);
                this.router.navigate(['/home/content']);
              }
            }
          }
        } else if (dat.code === 601) {
          this.messageService.add({severity: 'error', summary: 'error', detail: "Fecha o carnet no coinciden.", sticky: false});
            this.env.isContentLoading = false;
        } else {
          //tslint:disable-next-line:max-line-length
          //this.messageService.add({severity: 'error', summary: 'error', detail: this.Rc.getStringRC('global_message_' + dat.result.error.code), sticky: false});
          
          this.messageService.add({severity: 'error', summary: 'error', detail: "Lo sentimos, no fue posible realizar la petición. Por favor intente más tarde.", sticky: false});
            this.env.isContentLoading = false;
          
        }
      });
      /*
    this.realm.countries$.subscribe(data => {
      // @ts-ignore
      this.items = data.data.countryAppSettingsOrms;
    });*/
    /*
    this.Rc.fetchActivate().then(() => {
      this.countryTitle = this.Rc.getStringRC('global_select_country_title');
      this.cardTitle = this.Rc.getStringRC('global_card_number_label');
      this.dateTitle = this.Rc.getStringRC('global_birthday_label');
      this.loginBtnTitle = this.Rc.getStringRC('global_accept');
    });*/

    this.userform = this.fb.group({
      cardnumber: new FormControl('', [Validators.required, Validators.minLength(4)]),
      date: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      rememberData: new FormControl('', Validators.required)
    });
    this.selectedCity = this.userform.get('country').value;
}

async getCountry() {
  this.countryReq = await this.firebase.getStringRC('country_validation');   
  //this.countryReq = 'HN';
  console.log('country_validation' + this.countryReq);
  this.env.usrGTM = this.countryReq == 'GT';
  this.env.usrHN = this.countryReq == 'HN';
}

padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}

formatDate(date) {
  return [
    this.padTo2Digits(date.getDate()),
    this.padTo2Digits(date.getMonth() + 1),
    date.getFullYear(),
  ].join('/');
}

async getCardNumbers() {
  this.idWithOutValidation = await this.firebase.getStringRC('demobrokerlist');
  //console.log('cardNumbers' + this.idWithOutValidation);
  this.cards = this.idWithOutValidation.split(',');
  console.log("this.cards: ", this.cards);
}

async getPoliciesExclude() {
  this.policiesExclude = await this.firebase.getStringRC('hide_contact_policy');
  this.env.policiesExclude = this.policiesExclude;
  this.st.saveParam('policiesExcludeSess', this.env.policiesExclude);
  console.log('hide_contact_policy: ' + this.env.policiesExclude);
}

setvalues() {
  const t =  this.items[0];
  this.userform.patchValue({
    country: t,
    cardnumber: '502605020',
    date: new Date('1990-06-22T06:00:00.000Z'),
  });
}
onSubmit(value: string) {
  this.env.isContentLoading = true;
  this.submitted = true;
  const q = JSON.parse(JSON.stringify(value));
  const datePipe = new DatePipe('es-MX');
  const newDate = new Date(q.date);
  this.cCode = q.country.code;
  this.dob = datePipe.transform(newDate, this.masks, 'es-MX');
  this.card = q.cardnumber;
  this.card = this.card.replace("-","");
  this.saveCookies = q.rememberData;
  
  
  this.realm.getLoginSettings(this.card, this.dob, this.cCode);
  
}

ngAfterViewInit() {
  this.env.isContentLoading = false;
}

Login() {
  if (this.countryTitle==undefined) {
    this.messageService.clear();
    this.messageService.add({severity: 'error', summary: 'Por favor seleccione el país', sticky: false});
  } else if (this.datetmp==undefined) {
    this.messageService.clear();
    this.messageService.add({severity: 'error', summary: 'Por favor ingrese la fecha de nacimiento', sticky: false});
  } else if (this.card=="") {
    this.messageService.clear();
    this.messageService.add({severity: 'error', summary: 'Por favor ingrese su número de carné', sticky: false});
  } else {
    this.messageService.clear();
    this.messageService.add({severity: 'info', summary: 'Ingresando', sticky: false});

    this.env.isContentLoading = true;
    this.submitted = true;
    const datePipe = new DatePipe('es-MX');
    const newDate = new Date(this.datetmp);
    this.cCode = this.countryTitle.code;
    this.dob = datePipe.transform(newDate, this.masks, 'es-MX');
    //this.card = q.cardnumber;
    this.card = this.card.replace("-","");
    //this.saveCookies = q.rememberData;
    
    this.realm.getLoginSettings(this.card, this.dob, this.cCode);
  }
  
  
}

  onKeyDate(event: any) {
    event.target.value = event.target.value.replace(/^(\d{2})(\d{2})/, '$1/$2/');
    //console.log(event.target.value);
  }

  showDialog() {
    this.display = true;
}

handleChange(e) {
  this.saveCookies = e.checked;
  console.log("savecookies: "+ this.saveCookies);
}

cannotLogin() {
  this.router.navigate(['/cannot-login']);
}

forgotId() {
  this.router.navigate(['/forgot-id']);
}
}
